import(/* webpackMode: "eager", webpackExports: ["PlayerAvatar"] */ "/app/apps/web/src/components/common/image/player-avatar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TriviaGameLoginLayout"] */ "/app/apps/web/src/components/trivia-rumble/trivia-game-login.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TriviaGamePanel"] */ "/app/apps/web/src/components/trivia-rumble/trivia-game-panel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TriviaLeaderboardSection"] */ "/app/apps/web/src/components/trivia-rumble/trivia-leaderboard-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@3.25.3_next@15.5.18_@opentelemetry+api@1.8.0_react-dom@19.2.6_react@19.2.6__r_2a2f0678776bbe3713c81e2fe0d56fd2/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.18_@babel+core@7.28.5_@opentelemetry+api@1.8.0_react-dom@19.2.6_react@19.2.6__react@19.2.6_sass@1.79.4/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionTrigger","AccordionContent"] */ "/app/packages/ui/components/arccordion/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Mobile"] */ "/app/packages/ui/components/responsive/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/features/leaderboard/leaderboard-row.tsx");
